export const generateId = (componentType, featureName, uniqueId = "") => {
  return `${componentType}-${featureName}${uniqueId ? `-${uniqueId}` : ""}`;
};

export const generateContentName = (componentLabel, uniqueId = "") => {
  return uniqueId ? `${componentLabel} ${uniqueId}` : componentLabel;
};
